import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { EntitySelector } from "./entitySelector";
import { makeStyles, tokens } from "@fluentui/react-components";
import { TextureUpload } from "../hoc/textureUpload";
const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: tokens.spacingHorizontalS,
    },
});
/**
 * A primitive component with a ComboBox for selecting from existing scene textures
 * and a button for uploading new texture files.
 * @param props TextureSelectorProps
 * @returns TextureSelector component
 */
export const TextureSelector = (props) => {
    TextureSelector.displayName = "TextureSelector";
    const { scene, cubeOnly, value, onChange, onLink, defaultValue } = props;
    const classes = useStyles();
    const getTextures = useCallback(() => scene.textures, [scene.textures]);
    const getName = useCallback((texture) => texture.displayName || texture.name || `${texture.getClassName() || "Unnamed Texture"} (${texture.uniqueId})`, []);
    const filter = useCallback((texture) => !cubeOnly || texture.isCube, [cubeOnly]);
    return (_jsxs("div", { className: classes.container, children: [_jsx(EntitySelector, { value: value, onChange: onChange, onLink: onLink, defaultValue: defaultValue, getEntities: getTextures, getName: getName, filter: filter }), !value && _jsx(TextureUpload, { scene: scene, onChange: onChange, cubeOnly: cubeOnly })] }));
};
//# sourceMappingURL=textureSelector.js.map